module.exports = __webpack_public_path__ + "img/placket_width.ad734381.png";